export default "__VITE_ASSET__BSX4lZX$__"